import { render, staticRenderFns } from "./LandUseAndCoverMobile.vue?vue&type=template&id=7f1784d2&scoped=true"
import script from "./LandUseAndCoverMobile.vue?vue&type=script&lang=js"
export * from "./LandUseAndCoverMobile.vue?vue&type=script&lang=js"
import style0 from "./LandUseAndCoverMobile.vue?vue&type=style&index=0&id=7f1784d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1784d2",
  null
  
)

export default component.exports